var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RadioGroup", {
        attrs: { options: _vm.typeOptions },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.type,
          callback: function($$v) {
            _vm.type = $$v
          },
          expression: "type"
        }
      }),
      _vm._v(" "),
      _vm.itemsEligible
        ? _c("SelectInline", {
            staticClass: "mt-4",
            attrs: {
              "characteristic-items": _vm.meta.managementKind,
              "characteristic-type": _vm.meta.managementKindType,
              "initial-show-all": "",
              "label-type": "application"
            },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.items,
              callback: function($$v) {
                _vm.items = $$v
              },
              expression: "items"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }